<template>
  <div class="chart px-5">
    <h1 style="font-weight:600" class="pt-5 font-family-card text-lg md:text-[27px] pl-8">Trending Graph (Collected vs Disposed)</h1>
    <!-- <div class="flex pt-7 md:pb-2 pb-1 justify-center"> -->
    <!-- <div ref="legendContainer" class="flex"></div> -->
    <!-- </div> -->
    <canvas ref="chartCanvas" height="35" width="100%" class="pb-5"></canvas>
  </div>
</template>

<script setup>
import { onMounted, ref, watchEffect } from 'vue';
import Chart from 'chart.js/auto';
import { defineProps } from 'vue';
const props = defineProps({
  tranding: Object,
});

const chartCanvas = ref(null);
const legendContainer = ref(null);

onMounted(() => {
  watchEffect(() => {
    if (chartCanvas.value && props.tranding) {
      const ctx = chartCanvas.value.getContext('2d');

      if (ctx) {
        if (chartCanvas.value.chart) {
          chartCanvas.value.chart.destroy();
        }

        // Extracting data from props
        const collectionData = props.tranding.collectionData || [];
        const incinerationData = props.tranding.IncinerationData || [];

        const labels = collectionData.map(entry => entry.month);

        const collectedData = collectionData.map(entry => entry.collection_count);
        const incineratedData = incinerationData.map(entry => entry.incineration_count);

        chartCanvas.value.chart = new Chart(ctx, {
          type: 'line',
          data: {
            labels: labels,
            datasets: [
              {
                label: 'Collected',
                data: collectedData,
                backgroundColor: '#85A9FB',
                borderColor: '#85A9FB',
                borderWidth: 1,
                borderRadius: 5,
              },
              {
                label: 'Disposed',
                data: incineratedData,
                backgroundColor: '#2E2C72',
                borderColor: '#2E2C72',
                borderWidth: 1,
                borderRadius: 5,

              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: true,
            top: 'end',
            plugins: {
              legend: {
                display: true,
                labels: {
                  color: '#000000',
                  boxWidth: 15,
                  useBorderRadius: true,
                  borderRadius: 2,
                  boxHeight: 15,
                  font: {
                    size: 16
                  },
                  title: {
                    color: '#000000',
                    padding: 20
                  }

                },
              },

            },

            scales: {
              indexAxis: 'y',
              y: {
                title: {
                  display: true,
                  text: 'Weight (KGs)',
                  padding: {
                    top: 10,
                    bottom: 10
                  }
                },
                suggestedMin: 30,
                suggestedMax: 100,
                beginAtZero: true,
                weight: 10,

                ticks: {
                  stepSize: 10, // Adjust the step size as needed
                  suggestedMin: 50,
                  suggestedMax: 500,
                },
              },
            },
          },
        });

        // Generate and set the custom legend HTML
        if (legendContainer.value) {
          legendContainer.value.innerHTML = generateLegend(chartCanvas.value.chart);
        }
        // Attach click event listener to legend items
        if (legendContainer.value) {
          legendContainer.value.addEventListener('click', handleLegendItemClick);
        }
      } else {
        console.error('Canvas context is not available.');
      }
    }
  });
});

// Function to generate custom legend HTML
function generateLegend(chart) {
  const legendItems = chart.legend.legendItems.map((item) => {
    const colorBox = `<span style="background-color: ${item.fillStyle}; border-radius:3px; width: 15px; height: 15px; display: inline-block; margin-right: 5px;"></span>`;
    return `<li class="pr-5" style="list-style-type: none; align-items:center; display:flex">${colorBox}${item.text}</li>`;
  });

  return `<ul class="flex " style="padding: 0;">${legendItems.join('')}</ul>`;
}
function handleLegendItemClick(event) {
  const clickedIndex = event.target.getAttribute('data-index');
  if (clickedIndex !== null) {
    const datasetIndex = parseInt(clickedIndex, 10);

    if (chartCanvas.value.chart) {
      const meta = chartCanvas.value.chart.getDatasetMeta(datasetIndex);
      if (meta) {
        // Toggle visibility of the clicked dataset
        meta.hidden = !meta.hidden;

        // Update legend
        updateLegend();
      } else {
        console.error('Chart meta information not available.');
      }
    } else {
      console.error('Chart instance not available.');
    }
  }
}



function updateLegend() {
  // Use the update method of the chart instance
  chartCanvas.value.chart.update();
}
</script>

<style scoped>
/* Add any scoped styles if needed */
</style>
